// 设备管理英文文案
const en = {
  categoryManagement: "Equipment Category Management",
  addOrEditEquipmentCategory: "Add/Edit Equipment Category",
  addOrEditEquipmentInfo: "Add/Edit Equipment Information",
  addRootCategory: "Add Main Category",
  addSubCategory: "Add Subcategory",
  batchSubCategories: "Subcategories",
  addBatchSubCategory: "Add Subcategory",
  removeSubCategory: "Remove Subcategory",
  subCategoryItem: "Subcategory {{index}}",
  editCategory: "Edit Category",
  disableCategory: "Disable Category",
  enableCategory: "Enable Category",
  categoryCode: "Category Code",
  categoryName: "Category Name",
  categoryDesc: "Category Description",
  sortOrder: "Sort Order",
  level: "Level",
  enabled: "Enabled",
  disabled: "Disabled",
  selectCategoryPlaceholder: "Select an equipment category",
  noCategoryData: "No equipment categories",
  categoryCodeRequired: "Enter the category code",
  categoryNameRequired: "Enter the category name",
  confirmDisableCategory: "Disabling this category also disables all subcategories. Continue?",
  confirmEnableCategory: "Enabling this category also enables all parent categories. Continue?",
  categoryFetchFailed: "Equipment category operation failed",
  categoryOperationSucceeded: "Equipment category operation succeeded",
  equipmentLedger: "Equipment List",
  myBorrowed: "My Borrowed Equipment",
  maintainUpcoming: "Maintenance Due",
  maintainUpcomingQuery: "Maintenance Due Query",
  equipmentList: "Equipment List",
  addEquipment: "Add Equipment",
  editEquipment: "Edit Equipment",
  equipmentDetail: "Equipment Details",
  equipmentCategory: "Equipment Category",
  equipmentNumber: "Equipment Number",
  equipmentName: "Equipment Name",
  equipmentKeywordPlaceholder: "Enter an equipment keyword",
  equipmentStatus: "Equipment Status",
  brand: "Brand",
  model: "Model",
  serialNo: "Serial Number",
  qrCode: "QR Code",
  disableEquipment: "Disable",
  enableEquipment: "Enable",
  maintenanceRecord: "Maintenance",
  borrowEquipment: "Borrow",
  returnEquipment: "Return",
  recordFlow: "Record Log",
  recordDetail: "Record Details",
  operator: "Operator",
  borrower: "Borrower",
  returnAt: "Actual Return Time",
  confirmDisableEquipment: "Disable this equipment?",
  confirmEnableEquipment: "Enable this equipment?",
  equipmentStateUpdated: "Equipment status updated",
  equipmentStateUpdateFailed: "Failed to update equipment status",
  qrCodeFetchFailed: "Failed to load the QR code",
  noQrCodeData: "No QR code data",
  addMaintenanceRecord: "Add Maintenance Record",
  recordType: "Record Type",
  recordTypeRequired: "Select a record type",
  occurredAt: "Occurred At",
  occurredAtRequired: "Select the occurrence time",
  expectedReturnAt: "Expected Return Time",
  scrapEquipment: "Scrap",
  confirmScrapEquipment: "Scrapping is irreversible. Continue?",
  recordCost: "Cost",
  recordCostCurrency: "Currency",
  odometer: "Usage",
  vendor: "Service Provider",
  recordComment: "Remarks",
  recordTypesFetchFailed: "Failed to load record types",
  recordListFetchFailed: "Failed to load record history",
  recordFetchFailed: "Failed to load record details",
  noRecordDetail: "No record details",
  addRecordSucceeded: "Maintenance record added",
  addRecordFailed: "Failed to add the maintenance record",
  keeperOrg: "Custodian Department",
  ownedOrg: "Purchasing/Owning Department",
  currentUser: "Current User",
  location: "Location",
  placeLocation: "Placement Location",
  editPlaceLocation: "Edit Placement Location",
  placeLocationUpdateSucceeded: "Placement location updated",
  placeLocationUpdateFailed: "Failed to update placement location",
  maintainDays: "Maintenance Cycle (Days)",
  maintainThreshold: "Maintenance Cycle (Usage)",
  dueByDays: "Days Dimension",
  dueByThreshold: "Usage Dimension",
  due: "Due",
  notDue: "Not Due",
  remainDays: "Remaining Days",
  remainThreshold: "Remaining Usage",
  lastMaintainAt: "Last Maintenance Time",
  lastMaintainOdometer: "Previous Usage",
  currentOdometer: "Current Usage",
  purchaseInfo: "Purchase Information",
  purchaseAt: "Purchase Date",
  purchasePrice: "Purchase Price",
  purchaseCurrency: "Purchase Currency",
  supplier: "Supplier",
  createdBy: "Created By",
  createdAt: "Created At",
  updatedBy: "Updated By",
  updatedAt: "Updated At",
  actions: "Actions",
  equipmentNameRequired: "Enter the equipment name",
  keeperOrgRequired: "Select the custodian department",
  rootCategoryCannotAdd: "Equipment cannot be added to a root category. Select a subcategory",
  addEquipmentSucceeded: "Equipment added successfully",
  editEquipmentSucceeded: "Equipment updated successfully",
  equipmentSaveFailed: "Failed to save equipment",
  equipmentFetchFailed: "Failed to load equipment details",
  equipmentListFetchFailed: "Failed to load the equipment list",
  myBorrowedFetchFailed: "Failed to load borrowed equipment",
  upcomingMaintainFetchFailed: "Failed to load maintenance-due equipment",
  equipmentStatusFetchFailed: "Failed to load equipment statuses",
  noEquipmentDetail: "No equipment details",
};

export default en;
